/*
 * Copyright (c) 2018. CPP, Inc. All rights reserved.
 * Also protected by Patent Pending: 15/916,593
 */

import PropTypes from 'prop-types'
import { compose, mapProps, pure, setPropTypes } from 'recompose'

import barPlotShape from 'shapes/BarPlot'
import barPlotNavigationShape from 'shapes/BarPlotNavigation'
import docNavShape from 'shapes/DocumentNavigation'

import processBarPlot from 'utils/processQueries/barPlot'
import processBarPlotNav from 'utils/processQueries/barPlotNavigation'
import processDocNav from 'utils/processQueries/documentNavigation'

export const BarPlot = compose(
  pure,
  mapProps(({ data: { barPlot, barPlots, docs }, ...props }) => {
    return {
      ...props,
      barPlot: processBarPlot(barPlot),
      barPlotNavigation: processBarPlotNav(barPlots),
      documentNavigation: processDocNav(docs),
    }
  }),
  setPropTypes({
    className: PropTypes.string,
    barPlot: barPlotShape.single,
    barPlotNavigation: barPlotNavigationShape.list,
    documentNavigation: docNavShape.list,
  })
)

export default BarPlot
